import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ExploreService } from '../../../services/API/explore.service/exploreservice';
import { ToastrService } from 'ngx-toastr';
import { NgClass, NgIf } from '@angular/common';
import { drawCanvas } from '../../../utils/helper.';
import { Router } from '@angular/router';
import { StorageService } from '../../../services/state-management/storage.service/storage.service';
import { FormsModule } from '@angular/forms';
import { Art } from '../../../models/classes/art.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ROLE } from '../../../models/constant/constants';
import { GuestLoginComponent } from "../../../modal/guest-login/guest-login.component";

@Component({
  selector: 'app-user-card',
  standalone: true,
  imports: [NgIf,NgClass, FormsModule, GuestLoginComponent],
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
})
export class UserCardComponent implements OnInit {
  @Input() card!: Art;
  @Input() showArtist:boolean = true;
  @Input() heightAuto:boolean = false;
  @Input() showLike:boolean = true;
  @Input() showValidationMessage = true;
  @Input() userIsSelecting:boolean = false;
  @Input() isSelectionEnabled = false;
  @Input() selectOrder = 0;

  @Output() cardClick = new EventEmitter<any>();
  @Output() likeClick = new EventEmitter<{ id: number; likeUnlikeStatus: boolean, artistId:number }>();
  @Output() onUserSelect = new EventEmitter<boolean>();
  @Output() openGuestLoginPopup = new EventEmitter<null>();
  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('selectInput') selectInputRef!: ElementRef<HTMLInputElement>;
  
  role:ROLE = ROLE.GUEST
  isArtDetailsOpen = false;
  liked = false;
  artistId:string | number = 0;
  isLoginPopupOpen = false;

  constructor(
    private exploreService: ExploreService,
    private toaster: ToastrService,
    private storageService:StorageService,
    private router:Router,
  ) {}

  ngOnInit(): void {
    this.card = new Art(this.card);
    this.liked = this.card.likeUnlikeStatus;
    this.storageService.getRole().subscribe(role => this.role = role);
    this.artistId = this.storageService.getArtistId();
  }

  onCardClick(): void {
    if(this.userIsSelecting) {
      this.selectInputRef.nativeElement.click();
      this.select();
      return;
    }
    this.cardClick.emit(this.card);
  }

  toggleLike(event: Event): void {
    event.stopPropagation();
    if(this.role === ROLE.GUEST) {
      this.isLoginPopupOpen = true;
      return;
    }
    this.exploreService.likeUnlikeArts(this.card.id, this.card.artistId).subscribe({
      next: (res:any) => {
        this.liked = !this.liked;
        this.card.likeUnlikeStatus = this.liked;
        this.toaster.success(res.message);
        this.likeClick.emit({ id: this.card.id, likeUnlikeStatus: this.liked, artistId:this.card.artistId });
      },
      error: (error:HttpErrorResponse) => {
        this.toaster.error(error.error?.message || error.message);
      },
    });
  }

  ngAfterViewInit(): void {
    drawCanvas(
      this.canvasRef.nativeElement,
      this.card?.artThumbnailUploadUrl || this.card?.artThumbnailUrl || this.card?.imageUrl || this.card?.artUploadUrl,
      this.card.watermark,
      this.card?.nameAsSignature ? null : this.card.signature,
      this.card.artistName,
      250,
      180,
      0,0,
      10
    )
  }

  toggleArtDetails(): void {
    this.isArtDetailsOpen = !this.isArtDetailsOpen;
  }

  redirectToProfile(cardDetails:any) {
    if(cardDetails.artistUserName || cardDetails?.artistUsername)
      this.router.navigateByUrl(`artist/${cardDetails?.artistUserName || cardDetails?.artistUsername}`);
  }

  protected select(e?:MouseEvent): void {
    if(this.role === ROLE.GUEST) {
      this.openGuestLoginPopup.emit();
      return;
    }
    if(!e) return;
    if(!this.card.price || (this.showValidationMessage && this.card.subscribed) || this.card.artistId == this.artistId){
      this.selectInputRef.nativeElement.checked = false;
      return;
    }

    this.onUserSelect.emit(this.selectInputRef.nativeElement.checked);
  }

}
